/*!
 * Immediately Invoked Function Expression Boilerplate
 * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
 */

// include micromodal node module
import MicroModal from "micromodal";

// swiper
import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';

;(function () {
	'use strict';

// Element variables
const menuToggle = document.querySelector('.open-menu');
const navMenu = document.querySelector('.site-header__flyout-menu');
const menuOverlay = document.querySelector('.site-header__flyout-menu-overlay');

const elementExists = (element) => typeof element !== 'undefined' && element !== null;

// Function to toggle menu open/close
const toggleMenu = (event) => {
    if (!event.target.closest('.open-menu')) return;
    if (elementExists(navMenu)) {
        navMenu.classList.toggle('active');
    }
    menuToggle.classList.toggle('active');
};

// Function to close menu
const closeMenu = (event) => {
    if (event.target.closest('.close-menu')) {
        if (elementExists(navMenu)) {
            navMenu.classList.remove('active');
        }
        if (elementExists(menuToggle)) {
            menuToggle.classList.remove('active');
        }
        return;
    }

    if (menuOverlay && event.target === menuOverlay) {
        if (elementExists(navMenu)) {
            navMenu.classList.remove('active');
        }
        if (elementExists(menuToggle)) {
            menuToggle.classList.remove('active');
        }
    }
};

// Function to toggle sub-menu
const toggleSubMenu = (event) => {
    if (!event.target.closest('.submenu-expand')) return;

    const submenuButton = event.target.closest('.submenu-expand');
    const menuItem = submenuButton.closest('.menu-item-has-children');
    const isExpanded = submenuButton.classList.toggle('expanded');

    // Check if this is a top-level menu item in #primary-menu
    const isTopLevelPrimaryMenuItem =
        menuItem &&
        menuItem.parentElement.id === 'primary-menu' &&
        menuItem.parentElement.contains(menuItem.closest('#primary-menu > .menu-item-has-children'));

    // Handle menu-open class on body only for top-level primary menu items
    if (isTopLevelPrimaryMenuItem) {
        if (isExpanded) {
            document.body.classList.add('menu-dropdown-open');
        } else {
            const anyExpanded = document.querySelector('#primary-menu > .menu-item-has-children .submenu-expand.expanded');
            if (!anyExpanded) {
                document.body.classList.remove('menu-dropdown-open');
            }
        }
    }

    event.preventDefault();
};

// Function to handle close sub-menu button inside .sub-menu-panel
const handleCloseSubMenuButton = (event) => {
    if (!event.target.closest('.sub-menu-panel__close-btn')) return;

    console.log('closeSubMenuButton clicked'); // Debugging log
    document.querySelectorAll('.submenu-expand.expanded').forEach((btn) => btn.classList.remove('expanded'));
    document.body.classList.remove('menu-dropdown-open');
};

// Event listeners
document.addEventListener('click', (event) => {
    toggleMenu(event);
    toggleSubMenu(event);
    closeMenu(event);
    handleCloseSubMenuButton(event); // Now listens for dynamically added close buttons
});
	// Function to handle sticky class
	const siteHeader = document.querySelector('.site-header');

	// Function to handle scrolling
	const handleScroll = function() {
		if (!elementExists(siteHeader)) return;

		if (window.scrollY > 0) {
			siteHeader.classList.add('scrolled');
		} else {
			siteHeader.classList.remove('scrolled');
		}
	};

	let isScrolling = false;

	// Add event listener to the scroll event
	window.addEventListener('scroll', function() {
		if (!isScrolling) {
			window.requestAnimationFrame(function() {
				handleScroll();
				isScrolling = false;
			});
			isScrolling = true;
		}
	});


	// Micromodals
	// for Enquire form, on all pages
	MicroModal.init();

	// Tabs (on Single Tours)
	document.addEventListener('DOMContentLoaded', () => {
		const tabs = document.querySelectorAll('.tab');
		const panels = document.querySelectorAll('.tab-content');

		tabs.forEach((tab) => {
			tab.addEventListener('click', () => {
				// Deactivate all tabs
				tabs.forEach((t) => {
					t.setAttribute('aria-selected', 'false');
					document.getElementById(t.getAttribute('aria-controls')).hidden = true;
				});

				// Activate clicked tab
				tab.setAttribute('aria-selected', 'true');
				document.getElementById(tab.getAttribute('aria-controls')).hidden = false;
			});
		});
	});


	/* Destination Taxonomy Term sliders
	------------------------------------------------------------ */

	document.querySelectorAll('.destination-grid .swiper').forEach((swiperElement) => {
		const swiperInstance = new Swiper(swiperElement, {
			modules: [Navigation, Pagination],
			loop: false,
			spaceBetween: 30,
			slidesPerView: 1.25,
			slideClass: 'card-summary',
			mousewheel: {
				enabled: true,
				forceToAxis: true,
				thresholdDelta: 5
			},
			grabCursor: true,
			navigation: {
				nextEl: swiperElement.querySelector('.swiper-button-next'),
				prevEl: swiperElement.querySelector('.swiper-button-prev'),
			},
			scrollbar: {
				el: swiperElement.querySelector('.swiper-scrollbar'),
				draggable: true,
				hide: true
			},
			breakpoints: {
				728: {
					slidesPerView: 3.5,
				}
			},
		});
	});


	// Smooth Scroll JS
	document.addEventListener('DOMContentLoaded', function () {

		function ea_scroll(hash) {
			var target = null;

			try {
				target = document.querySelector(hash);
			} catch (error) {
				// Perhaps worth adding some error logging here in the future.
				return false;
			}

			target = target ? target : document.querySelector('[name="' + hash.slice(1) + '"]');
			if (target) {
				var top_offset = 0;

				// Retrieve the CSS variable value for --wp--custom--site-header--height
				const rootStyles = getComputedStyle(document.documentElement);
				const cssHeaderHeight = rootStyles.getPropertyValue('--wp--custom--site-header--height').trim();

				// Convert CSS variable value to pixels (fallback to 60 if invalid)
				top_offset = cssHeaderHeight ? parseInt(cssHeaderHeight, 10) : 60;

				// Add admin bar offset if present
				const adminBar = document.getElementById('wpadminbar');
				if (document.body.classList.contains('admin-bar') && adminBar) {
					top_offset += adminBar.offsetHeight;
				}

				window.scrollTo({
					top: target.getBoundingClientRect().top + window.scrollY - top_offset,
					behavior: 'smooth'
				});
				return false;
			}
		}

		// -- Smooth scroll on pageload
		if (window.location.hash) {
			ea_scroll(window.location.hash);
		}

		// -- Smooth scroll on click
		document.querySelectorAll('a[href*="#"]:not([href="#"]):not(.no-scroll)').forEach(function(anchor) {
			anchor.addEventListener('click', function (event) {
				if (location.pathname.replace(/^\//, '') === anchor.pathname.replace(/^\//, '') && location.hostname === anchor.hostname) {
					event.preventDefault();
					ea_scroll(anchor.hash);
				}
			});
		});

	});


})();
